import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SaleCheckoutPageRoutingModule } from './sale-checkout-routing.module';

import { SaleCheckoutPage } from './sale-checkout.page';

import { SalonMonsterLoadMaskModule } from '../../components/smr-load-mask/smr-load-mask.module';
import { SalonMonsterTapRetryModule } from '../../components/smr-tap-retry/smr-tap-retry.module';
import { SharedModule } from '../../shared.module';
import { SalesSharedPageModule } from '../sales-shared/sales-shared.module';
import { TipsPaymentsManagerComponentModule } from '../sales-shared/components/tips-payments-manager/tips-payments-manager.module';
import { SaleTotalSummaryComponentModule } from '../sales-shared/components/sale-total-summary/sale-total-summary.module';
import { SaleClientComponentModule } from '../sales-shared/components/sale-client/sale-client.module';
import { SaleCheckoutButtonsComponentModule } from '../sales-shared/components/sale-checkout-buttons/sale-checkout-buttons.module';
import { SaleRefundPickerComponentModule } from '../sales-shared/components/sale-refund-picker/sale-refund-picker.module';
import { SaleRefundCardConfirmationComponentModule } from '../sales-shared/components/sale-refund-card-confirmation/sale-refund-card-confirmation.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    SaleCheckoutPageRoutingModule,
    SalonMonsterLoadMaskModule,
    SharedModule,
    SalonMonsterTapRetryModule,
    SalesSharedPageModule,
    TipsPaymentsManagerComponentModule,
    SaleTotalSummaryComponentModule,
    SaleClientComponentModule,
    SaleCheckoutButtonsComponentModule,
    SaleRefundPickerComponentModule,
    SaleRefundCardConfirmationComponentModule
  ],
  declarations: [SaleCheckoutPage]
})
export class SaleCheckoutPageModule {}
